export default __webpack_public_path__ + "static/media/profile_n.5d5c9e3a.jpg";